import { render, staticRenderFns } from "./redesign-step-6.vue?vue&type=template&id=5a0faca3&"
import script from "./redesign-step-6.vue?vue&type=script&lang=ts&"
export * from "./redesign-step-6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports